import debounce from 'lodash.debounce';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import Search from '../../components/shared/search/Search';
import { getUsersActions, setUsersSearchAction } from '../../redux/actions/usersActions';
import CreateUserModal from './modals/CreateUserModal';

const UsersHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.users?.search);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);

  const debounced = debounce((args) => {
    dispatch(setUsersSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  const handleUserModalSubmit = async () => {
    await dispatch(getUsersActions(search));
    setShowCreateUserModal(false);
  };

  return (
    <ContainerHeader>
      {showCreateUserModal && (
        <CreateUserModal
          onModalSubmit={() => handleUserModalSubmit()}
          onModalClose={() => setShowCreateUserModal(false)}
        />
      )}
      <Search value={search.search} onChangeAction={handleSearchChange} />
      {!readOnly && (
        <Button variant={'primary'} onClick={() => setShowCreateUserModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default UsersHeader;
